export default __webpack_public_path__ + "static/media/vyrill_logo.254706b0.png";